import { Consultant } from '@graphql/generated';
import { DemandeAffiliationParrain } from './../../models/demande-affiliation/demande-affiliation.model';
import { capitalize } from '@lib/core/utils';
export class ParrainMapper {
  public static fromGraphQL(input?: Consultant): DemandeAffiliationParrain | undefined {
    if (!input) return undefined;

    return {
      nom: input.personnePhysique?.[0]?.nom,
      prenom: input.personnePhysique?.[0]?.prenom,
      email: input.email?.[0]?.adresse,
      mobile: input.telephone?.[0]?.numero,
      qualification: capitalize(
        input.qualificationCodeNavigation?.libelle?.split(' ').pop()
      ),
    };
  }
}
